import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddTabPage = () => {

  // =========================
  // NAVIGATE
  // =========================

  const navigate = useNavigate();

  // =========================
  // STATE
  // =========================

  const [tabRows, setTabRows] = useState([
    {
      tabName: "",
      slug: ""
    }
  ]);

  const [addedBy, setaddedBy] = useState("");

  // =========================
  // ADD ROW
  // =========================

  const addTabRow = () => {

    setTabRows([
      ...tabRows,
      {
        tabName: "",
        slug: ""
      }
    ]);

  };

  // =========================
  // REMOVE ROW
  // =========================

  const removeTabRow = async (index) => {

    if (tabRows.length === 1) {
      toast.error("At least one row required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updated = tabRows.filter(
      (_, i) => i !== index
    );

    setTabRows(updated);

  };

  // =========================
  // HANDLE INPUT CHANGE
  // =========================

  const handleTabChange = (
    index,
    field,
    value
  ) => {

    const updatedRows = [...tabRows];

    updatedRows[index][field] = value;

    // AUTO GENERATE SLUG
    if (field === "tabName") {

      updatedRows[index].slug = value
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");

    }

    setTabRows(updatedRows);

  };

  // =========================
  // SAVE TAB
  // =========================

const saveTab = async () => {

  // =========================================
  // VALIDATION
  // =========================================

  const hasEmptyName = tabRows.some(
    (row) => !row?.tabName?.trim()
  );

  if (hasEmptyName) {
    toast.error("Tab Name is required");
    return;
  }

  const hasEmptySlug = tabRows.some(
    (row) => !row?.slug?.trim()
  );

  if (hasEmptySlug) {
    toast.error("Tab Slug is required");
    return;
  }

  // =========================================
  // CONFIRMATION
  // =========================================

  const confirm = await Swal.fire({
    title: "Save Tab?",
    text: "Do you want to save this Tab?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes Save",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) {
    return;
  }

  try {

    // =========================================
    // PAYLOAD
    // =========================================

    const payload = {
      tabs: tabRows,
    };

    console.log("TAB SAVE PAYLOAD =>", payload);

    // =========================================
    // API
    // =========================================

    const res = await api.post(
      "/adminHolidays/holidays-tab-save",
      payload
    );

    console.log("TAB SAVE RESPONSE =>", res.data);

    // =========================================
    // SUCCESS
    // =========================================

    if (res.data?.success) {

      await Swal.fire({
        title: "Success",
        text: res.data.message || "Tab Saved Successfully",
        icon: "success",
      });

      // =========================================
      // RESET
      // =========================================

      setTabRows([
        {
          tabName: "",
          slug: "",
        },
      ]);

      // =========================================
      // NAVIGATE
      // =========================================

      navigate("/holidays/tabs/manage-tabs");

    } else {

      Swal.fire({
        title: "Error",
        text: res.data?.message || "Failed to save Tab",
        icon: "error",
      });

    }

  } catch (error) {

    console.error("TAB SAVE ERROR =>", error);
    console.error(
      "RESPONSE DATA =>",
      error?.response?.data
    );

    toast.error(
      error?.response?.data?.message ||
      "Server Error"
    );
  }
};

  // =========================
  // JSX
  // =========================

  return (

    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Add Tab
          </h4>

          <Link
            to="/tab/manage-tab"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>

      </div>

      <div className="row">

        {/* TABLE */}

        <div className="col-lg-12">

          <div className="card shadow-sm border-0">

            <div className="card-body">

              <table className="table table-hover table-bordered align-middle mb-0">

                <thead className="table-light">

                  <tr>

                    <th width="50">
                      Sl.No
                    </th>

                    <th>
                      Tab Name
                    </th>

                    <th>
                      Slug
                    </th>

                    <th width="120">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {tabRows.map(
                    (row, index) => (

                      <tr key={index}>

                        <td>
                          {index + 1}
                        </td>

                        {/* TAB NAME */}

                        <td>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Tab Name"
                            value={row.tabName}
                            onChange={(e) =>
                              handleTabChange(
                                index,
                                "tabName",
                                e.target.value
                              )
                            }
                          />

                        </td>

                        {/* SLUG */}

                        <td>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Slug"
                            value={row.slug}
                            onChange={(e) =>
                              handleTabChange(
                                index,
                                "slug",
                                e.target.value
                              )
                            }
                          />

                        </td>

                        {/* ACTION */}

                        <td>

                          <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={addTabRow}
                          >
                            <i className="fa fa-plus-square"></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              removeTabRow(index)
                            }
                          >
                            <i className="fa fa-trash"></i>
                          </button>

                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

        {/* SAVE BUTTON */}

        <div className="col-lg-12 text-center">

          <button
            className="btn btn-info text-white px-5 mt-3"
            onClick={saveTab}
          >
            Save Tab
          </button>

        </div>

      </div>

    </div>

  );

};

export default AddTabPage;